import ConfirmPaymentScreen from 'features/lineOfCredit/screens/confirmPayment/ConfirmPaymentScreen';
import React from 'react';

export default function Page() {
  return <ConfirmPaymentScreen />;
}
